<template>
    <div>

<!-- ACCOUNT LEVEL CONFIG FOR CHECK STATUS PAGE -->
        <v-card class="elevation-3 mb-4 justify-center blue-grey lighten-5" v-if="manageDefaults">
            <v-card-text>
                <v-container fluid>
                    <v-row  justify="space-between">
                        <v-col class="justify-center headline" cols="6" md="8">Report Configuration - Account Defaults</v-col>
                        <v-col class="text-right" cols="4" >
                            <v-btn color="secondary" class="elevation-1" small dark v-on:click="$emit('closeConfig')" style="margin-bottom:8px;">Close <v-icon dark right>keyboard_arrow_up</v-icon></v-btn>
                        </v-col>
                    </v-row>
                    <div class='configlead mb-3'>
                        <v-row>
                        <v-btn color="primary" class="elevation-1" small @click="manageDefaults = false" style="margin-bottom:8px; padding-left:8px; padding-right:8px; clear:both"> Switch to Check's Report Settings </v-btn>
                        </v-row>
                        <v-row>
                        <p>These settings configure the default settings for all Check Status Reports for this account.</p>
                        <p><b>If you set options on the individual check's settings the corresponding account wide settings will be ignored.</b></p>
                        <p>Some data in the page will not refresh until you close the configuration panel.</p>
                        </v-row>
                    </div>
                    <v-expansion-panels multiple >
                        <v-expansion-panel>
                            <v-expansion-panel-header class='sectiontitle'>
                                General Settings
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="helpicon" >
                                    <v-icon light right color="primary" @click="togglehelp('generalhelp')">{{ getIcon('help') }}</v-icon>
                                </div>
                                <v-row class="helptext" id="generalhelp" v-if="showhelp === 'generalhelp'"  >
                                    <p>The first setting <strong>Enables Public Status Pages</strong> for your account.  If this is enabled, any checks on your account
                                        that are marked "public" in the check settings will automatically have public status pages for that individual check.  Unlike many
                                        other options in your account-wide settings, turning this off here overrides the settings on the individual check report configuration.
                                        This means that if you Disable the report here, you will not have any public status reports for individual checks for your account at all,
                                        regardless of the "public" setting on the individual checks themselves.
                                    </p>
                                    <p><strong>The Banner</strong> is displayed at the top of the report.  You can put a report title here, or a full HTML banner with your logo.
                                    This block can by styled using the #reportTitleContainer id in the CSS block under "Custom Content".  If you don't want a banner or title
                                    (for example, if you embed this report in something else), just leave this field blank. The Banner block supports variables for the check
                                    label, target, and type.  To use the variables, enclose the variable name in curly braces: {label}, {target}, or {type} </p>
                                    <p>The <strong>Page Title</strong> setting controls the title tag in the page HEAD, which is used in most browsers as the window title.</p>
                                </v-row>
                                <v-container>
                                    <v-row  justify="space-between" style="width:100%">
                                        <v-checkbox :input-value="reports_checkstatus.reportConfig.enable" :label="getLabel('enable')"  @click.stop="saveConfig(!reports_checkstatus.reportConfig.enable, 'enable')" ></v-checkbox>
                                    </v-row>
                                    <v-row  justify="space-between" style="width:100%">
                                        <v-textarea name="title" :value="reports_checkstatus.reportConfig.title" :label="getLabel('noeventstext')" rows="2" auto-grow  @change="saveConfig($event, 'title')">
                                        </v-textarea>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-text-field name="pagetitle" :value="reports_checkstatus.reportConfig.pagetitle" :label="getLabel('pagetitle')" @change="saveConfig($event, 'pagetitle')" >
                                        </v-text-field>
                                    </v-row>
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header  class='sectiontitle'>Summary Panel</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="helpicon" >
                                    <v-icon light right color="primary" @click="togglehelp('checkconfighelp')">{{ getIcon('help') }}</v-icon>
                                </div>
                                <v-row  class='helptext' id="checkconfighelp">
                                    <p>The Summary Panel is used to summarize the overall status for the check.  You can set the text it will show
                                    if the check is up or down.  These text fields support filtered HTML, as well as variables for {label},
                                    {target} and {type}.</p>
                                    <p>The block can be styled using the CSS settings under "Custom Content" below.  The summary panel has an ID
                                        of "statusoverview", with classes available to style both up and down states ("summarytitleup" and "summarytitledown").
                                        Note that in order to override the styles already set, you'll need to be
                                        <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/Specificity" target="_blank">fairly specific</a> or use !important.  For example:
                                        setting the background color for .summaryblockdown won't work, but it does if you set it on div.dashboard.summaryblockdown. </p>
                                </v-row>
                                <v-container>
                                    <v-row style="width:100%">
                                        <v-checkbox :input-value="reports_checkstatus.reportConfig.showsummary" :label="getLabel('showsummary')" @click.stop="saveConfig(!reports_checkstatus.reportConfig.showsummary, 'showsummary')" ></v-checkbox>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-text-field name="summarytitleup" :value="reports_checkstatus.reportConfig.summarytitleup" :label="getLabel('summarytitleup')" @change="saveConfig($event, 'summarytitleup')" >
                                        </v-text-field>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-text-field name="summarytitledown" :value="reports_checkstatus.reportConfig.summarytitledown" :label="getLabel('summarytitleup')" @change="saveConfig($event, 'summarytitledown')" >
                                        </v-text-field>
                                    </v-row>
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header class='sectiontitle'>
                                Check Properties
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="helpicon" >
                                    <v-icon light right color="primary" @click="togglehelp('checkhelp')">{{ getIcon('help') }}</v-icon>
                                </div>
                                <v-row class="helptext" id="checkhelp" v-if="showhelp === 'checkhelp'"  >
                                    <p>The <strong>Check Properties</strong> block can display the key fields from the check's setup, as
                                        well as a link to the URL being monitored (for HTTP type checks).</p>
                                    <p><strong>Hide the target URL from the report</strong> causes the check's "target" field to not be sent to the report at all,
                                        which means it isn't available anywhere, including as a field in the banner.  This is intended to prevent
                                        data leakage, since for some checks the URL might be non-public information.</p>
                                    <p><strong>Note that if you turn off "Hide the target URL" it may take a minute or so for the link to display</strong>,
                                        since the prior setting means we won't have cached it for the browser.</p>
                                    <p>You can toggle which fields will be displayed in this section.  Some checks may have additional custom fields.
                                        For example, HTTP Parse and PUSH checks allow you to set up custom metrics to measure. Since those are specific
                                        to the check, they can be added or removed from the report on the check's report configuration.</p>
                                </v-row >
                                <v-container>
                                    <v-row style="width:100%">
                                        <v-checkbox :input-value="reports_checkstatus.reportConfig.showcheckproperties" :label="getLabel('hidecheckproperties')"  @click.stop="saveConfig(!reports_checkstatus.reportConfig.hidecheckproperties, 'hidecheckproperties')" ></v-checkbox>
                                    </v-row>
                                    <v-row style="width:100%">
                                        <v-checkbox :input-value="reports_checkstatus.reportConfig.hidetarget" :label="getLabel('hidetarget')"  @click.stop="saveConfig(!reports_checkstatus.reportConfig.hidetarget, 'hidetarget')" ></v-checkbox>
                                    </v-row>
                                    <div><h3>Individual Properties</h3></div>
                                    <v-row style="width:100%">
                                        <div class="col-md-6 col-sm-12" v-for="(item, idx) in showAccountCheckProps" v-bind:key="'configaccountcheckprops-' + idx">
                                            <v-checkbox :input-value="item.show" :label="item.title" @click.stop="saveConfig(!item.show, 'showprops', item.field)" ></v-checkbox>
                                        </div>
                                    </v-row>
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header class='sectiontitle'>
                                Uptime
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="helpicon" >
                                    <v-icon light right color="primary" @click="togglehelp('uptimehelp')">{{ getIcon('help') }}</v-icon>
                                </div>
                                <v-row class="helptext" id="uptimehelp" v-if="showhelp === 'uptimehelp'"  >
                                    <p>The <strong>Uptime Timeframe</strong> setting allows you to choose how uptime information will be displayed on the page.  Since what
                                    uptime data we fetch from the database is dependent on this setting, when you change this the data may not be immediately available, but
                                    it will refresh within a few seconds of closing the configuration panel. </p>
                                </v-row>
                                <v-container>
                                    <v-row  style="width:100%">
                                        <v-checkbox :input-value="reports_checkstatus.reportConfig.showuptime" :label="getLabel('showuptime')"  @click.stop="saveConfig(!reports_checkstatus.reportConfig.hideuptime, 'hideuptime')" ></v-checkbox>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-select :items="uptimespanoptions" :label="getLabel('uptimespan')" :value="reports_checkstatus.reportConfig.uptimespan" @input="saveConfig($event, 'uptimespan')" />
                                    </v-row>
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header class='sectiontitle'>
                                Check Results
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="helpicon" >
                                    <v-icon light right color="primary" @click="togglehelp('resultshelp')">{{ getIcon('help') }}</v-icon>
                                </div>
                                <v-row class="helptext" id="resultshelp" v-if="showhelp === 'resultshelp'"  >
                                    <p>These settings manage how results from the check will be displayed on the page.</p>
                                    <p><strong>The Results Title</strong> will appear above the two results displays, if they are turned on.</p>
                                    <p>If <strong>Show Field to Set Results Count</strong> is on, users will be able to enter set how many results to
                                        show in the chart and table.  Since we get the results for the chart and table at the same time, the setting
                                        applies to both.  By default, the report will display 300 results (5 hours on a 1 minute interval check).
                                        The report also supports putting a number in the URL path of the report, which will be used even if this
                                        field to set it within the page isn't showing.</p>
                                    <p>You can toggle <strong>Results Charts</strong> on or off as the default for your check status pages
                                        across your account.  There are additional settings available in the configuration for the individual
                                        check's status report.</p>
                                    <p>The <strong>Results Table</strong> displays invididual results in a table view.  As with other settings
                                        here, this sets the default settings for your account, which can be overwritten for individual checks.
                                        If a check has additional custom fields (<a href='/http_parse_check.html' target='_blank'>HTTP Parse</a>
                                        and <a href='/push_check.html' target='_blank'>PUSH</a> checks, for example), they can only be managed
                                        in the settings for that check's individual report.</p>
                                    <p>The <strong>Hide/Show Button</strong> will cause the table to not be shown when the page initially loads.
                                        Instead, there will be a button labeled "Show Results" that will display the table.  This toggle only works
                                        if the Results Table is enabled.</p>
                                </v-row>
                                <v-container>
                                    <v-row  justify="space-between" style="width:100%">
                                        <v-text-field name="resultstitle" :value="reports_checkstatus.reportConfig.resultstitle" :label="getLabel('resultstitle')" @change="saveConfig($event, 'resultstitle')" >
                                        </v-text-field>
                                    </v-row>
                                    <v-row  >
                                        <v-checkbox :input-value="reports_checkstatus.reportConfig.showresultslimit" :label="getLabel('showresultslimit')"  @click.stop="saveConfig(!reports_checkstatus.reportConfig.showresultslimit, 'showresultslimit')" ></v-checkbox>
                                    </v-row>

                                    <div class="sectionhead"><h3>Result Chart Settings</h3></div>
                                    <v-row  >
                                        <v-checkbox :input-value="reports_checkstatus.reportConfig.showchart" :label="getLabel('hidechart')"  @click.stop="saveConfig(!reports_checkstatus.reportConfig.hidechart, 'hidechart')" ></v-checkbox>
                                    </v-row>

                                    <v-row >
                                        Individual charts settings are specific to an individual check, and can be configured below.
                                    </v-row>

                                    <v-row class="sectionhead">
                                        <h3>Result Table Settings</h3>
                                    </v-row>
                                    <v-row >
                                        <v-checkbox :input-value="reports_checkstatus.reportConfig.showresultslist" :label="getLabel('hideresultslist')"  @click.stop="saveConfig(!reports_checkstatus.reportConfig.hideresultslist, 'hideresultslist')" ></v-checkbox>
                                    </v-row>
                                    <v-row >
                                        <v-checkbox :input-value="reports_checkstatus.reportConfig.showresultstoggle" :label="getLabel('showresultstoggle')" @click.stop="saveConfig(!reports_checkstatus.reportConfig.showresultstoggle, 'showresultstoggle')" ></v-checkbox>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-text-field name="resultstabletitle" :value="reports_checkstatus.reportConfig.resultstabletitle" :label="getLabel('resultstabletitle')" @change="saveConfig($event, 'resultstabletitle')" >
                                        </v-text-field>
                                    </v-row>
                                    <v-row class="sectionhead"><h3>Fields to Display in Table</h3></v-row>
                                    <v-row justify="space-between" v-for="(item, idx) in accountResultsTableFields" v-bind:key="'accountresultstable-' + idx">
                                        <div class="col-md-6 col-sm-12">
                                            <v-checkbox :input-value="item.show" :label="item.text || item.label" @click.stop="saveConfig(!item.show, 'resultstable', 'show', item.field)" ></v-checkbox>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                            <v-text-field :value="item.label" label="Label" @change="saveConfig($event, 'resultstable', 'label', item.field)" />
                                        </div>
                                    </v-row>
                                    <!-- <div class="showcheckfieldrow d-flex flex-wrap" >
                                        <div class="col-md-6 col-sm-12" v-for="(item, idx) in accountResultsTableFields" v-bind:key="'accountresultstable-' + idx">
                                            <v-checkbox :input-value="item.show" :label="item.label" @click.stop="saveConfig(!item.show, 'resultstable', item.field)" ></v-checkbox>
                                        </div>
                                    </div> -->
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header class='sectiontitle'>
                                Events
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="helpicon" >
                                    <v-icon light right color="primary" @click="togglehelp('eventhelp')">{{ getIcon('help') }}</v-icon>
                                </div>
                                <v-row class="helptext" id="eventhelp" v-if="showhelp === 'eventhelp'"  >
                                    <p>This section allows you to manage how Events History is displayed.</p>
                                    <p><strong>Show Events Block</strong> toggles whether the page will include an events history block.</p>
                                    <p><strong>Events Block Title</strong> allows you to optionally set a title for this part of the page.  The default is "Event History"</p>
                                    <p><strong>Pagination Interval</strong> sets how much event history we get at a time.  "All" makes the page display all events from the
                                    time the check was created or, if it's set, the "Do Not Show Events Older Than" setting.  Combining a pagination of "All" with "Show Days with No Events"
                                    is not recommended, because you might end up with a lot of days listed.</p>
                                    <p><strong>Do Not Show Events Older Than</strong> prevents querying for events older than the span of time indicated.</p>
                                    <p><strong>Show Days with No Events</strong> makes the page list each page in the timespan with a "No Events Reported" message (which you can set in the next field)</p>
                                    <p><strong>Text displayed when there are no events</strong> sets what to display if there are no events in the displayed interval (or on that day
                                    if you are displaying empty days).  Defaults to "No events reported".</p>
                                </v-row>
                                <v-container>
                                    <v-row  justify="space-between" style="width:100%">
                                        <v-checkbox :input-value="reports_checkstatus.reportConfig.showevents" :label="getLabel('hideevents')" @click.stop="saveConfig(!reports_checkstatus.reportConfig.hideevents, 'hideevents')" ></v-checkbox>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-text-field name="eventtitle" :value="reports_checkstatus.reportConfig.eventtitle" :label="getLabel('eventtitle')" @change="saveConfig($event, 'eventtitle')" >
                                        </v-text-field>
                                    </v-row>
                                    <v-row>
                                        <v-select :items="[{value:'all', text:'Get All Events'}, {value:'months', text:'One Month'}, {value:'weeks', text:'One Week'}, {value:'days', text:'One Day'}]" :label="getLabel('eventsinterval')" :value="reports_checkstatus.reportConfig.eventsinterval" @input="saveConfig($event, 'eventsinterval')" />
                                    </v-row>
                                    <v-row>
                                        <v-select :items="[{value:'all', text:'No limit'}, {value:'One week', text:'One Week'}, {value:'Two weeks', text:'Two Weeks'}, {value:'One month', text:'One Month'}, {value:'Three month', text:'Three Months'}]" :label="getLabel('eventsnotbefore')" :value="reports_checkstatus.reportConfig.eventsnotbefore" @input="saveConfig($event, 'eventsnotbefore')" />
                                    </v-row>
                                    <v-row>
                                        <v-checkbox :input-value="reports_checkstatus.reportConfig.showemptyeventdays" :label="getLabel('showemptyeventdays')" @click.stop="saveConfig(!reports_checkstatus.reportConfig.showemptyeventdays, 'showemptyeventdays')" ></v-checkbox>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-text-field name="noeventstext" :value="reports_checkstatus.reportConfig.noeventstext" :label="getLabel('noeventstext')" @change="saveConfig($event, 'noeventstext')" >
                                        </v-text-field>
                                    </v-row>
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header class='sectiontitle'>Custom Content - Banner, Footer, Support Content</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="helpicon" >
                                    <v-icon light right color="primary" @click="togglehelp('supportcontenthelp')">{{ getIcon('help') }}</v-icon>
                                </div>
                                <v-row class="helptext" id="supportcontenthelp" v-if="showhelp === 'supportcontenthelp'"  >
                                    <p>The Customizable Content blocks support either plain text or HTML.  A wide range of tags and attributes are supported, but there is some
                                        filtering to prevent misuse.  For example, script tags and event attributes will be removed.  Style attributes are supported, but we
                                        encourage you to use the CSS block instead of adding style attributes.</p>
                                    <p><strong>The Support Content</strong> blocks will appear just before (block 1) or just after (block 2) the results graph.  This is intended to
                                        display information useful to all visitors to your status page.  For example, you may want to display a link to
                                        contact support.  This block can be toggled on and off, for situational use.  To style this content, use the CSS block with the supportcontent class.</p>
                                    <p><strong>The Footer</strong> is at the bottom of the page, and can safely be left blank if you don't need it.  To style the Footer content, use the CSS
                                        block below with the #customfooter id.</p>
                                    <p><strong>The CSS</strong> entered here will be inserted into a &lt;style&gt; tag in the HEAD of the page.  There is some filtering on this block.  See the Report Documentation
                                        for more information on class and id properties that are available for the report.</p>
                                </v-row>
                                <v-container>
                                    <v-row>
                                        <v-checkbox :input-value="reports_checkstatus.reportConfig.shownote1" :label="getLabel('hidenote1')" @click.stop="saveConfig(!reports_checkstatus.reportConfig.hidenote1, 'hidenote1')" ></v-checkbox>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-textarea name="note1" :value="reports_checkstatus.reportConfig.note1" :label="getLabel('note1')" rows="2" auto-grow  @change="saveConfig($event, 'note1')">
                                        </v-textarea>
                                    </v-row>
                                    <v-row>
                                        <v-checkbox :input-value="reports_checkstatus.reportConfig.shownote2" :label="getLabel('hidenote2')" @click.stop="saveConfig(!reports_checkstatus.reportConfig.hidenote2, 'hidenote2')" ></v-checkbox>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-textarea name="note2" :value="reports_checkstatus.reportConfig.note2" :label="getLabel('note2')" rows="2" auto-grow  @change="saveConfig($event, 'note2')">
                                        </v-textarea>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-textarea name="footer" :value="reports_checkstatus.reportConfig.footer" :label="getLabel('footer')" rows="2" auto-grow  @change="saveConfig($event, 'footer')">
                                        </v-textarea>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-textarea name="stylecss" :value="reports_checkstatus.reportConfig.stylecss" :label="getLabel('stylecss')" rows="2" auto-grow  @change="saveConfig($event, 'stylecss')">
                                        </v-textarea>
                                    </v-row>
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                    </v-expansion-panels>
                </v-container>
            </v-card-text>
        </v-card>

<!-- THIS CHECK CONFIG -->

        <v-card v-else class="elevation-3 mb-4 justify-center">
            <v-card-text>
                <v-container fluid>
                    <v-row  justify="space-between">
                        <v-col class="justify-center headline" cols="6" md="8">Report Configuration - This Specific Check</v-col>
                        <v-col class="text-right" cols="4" >
                            <v-btn color="secondary" class="elevation-1" small dark v-on:click="$emit('closeConfig')"  style="margin-bottom:8px;">Close <v-icon dark right>keyboard_arrow_up</v-icon></v-btn>
                        </v-col>
                    </v-row>
                    <div class='configlead note mb-3'>
                        <v-row>
                            <v-btn color="primary" class="elevation-1" small @click="manageDefaults = true"  style="margin-bottom:8px; padding-left:8px; padding-right:8px; clear:both">Switch to Account Wide Settings</v-btn>
                        </v-row>
                        <v-row>
                            <p>These settings are for this specific check.  They override default settings and are applied to the status page for this specific check.  Click the button above to view and change the defaults
                            for the check status page for this account.</p>
                            <p>Some data in the page will not refresh until you close the configuration panel.</p>
                        </v-row>
                    </div>
                    <v-expansion-panels multiple >
                        <v-expansion-panel>
                            <v-expansion-panel-header class='sectiontitle'>
                                General Settings
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="helpicon" >
                                    <v-icon light right color="primary" @click="togglehelp('generalhelp')">{{ getIcon('help') }}</v-icon>
                                </div>
                                <v-row class="helptext" id="generalhelp" v-if="showhelp === 'generalhelp'"  >
                                    <p>The first setting toggles whether the status page for this check is <strong>public or private</strong>.  This toggles the public field
                                        on the check itself and governs all public reporting for this check.  Even if this is "private" users who are logged into your account
                                        will be able to access the report.
                                    </p>
                                    <p><strong>The Banner</strong> is displayed at the top of the report.  You can put a report title here, or a full HTML banner with your logo.
                                    This block can by styled using the #reportTitleContainer id in the CSS block under "Custom Content".  If you don't want a banner or title
                                    (for example, if you embed this report in something else), just leave this field blank. The Banner block supports variables for the check
                                    label, target, and type.  To use the variables, enclose the variable name in curly braces: {label}, {target}, or {type} </p>
                                    <p>The <strong>Page Title</strong> setting controls the title tag in the page HEAD, which is used in most browsers as the window title.</p>
                                    <p>The <strong>Access Phrase</strong> allows you to require people to enter an access phrase in order to access the report.
                                        This is for convenience to obscure non-public information.  <strong>This is not designed as a security feature, and is not
                                        encrypted.</strong> It is, for example, visible in your configuration settings. The Access Phrase field supports most special
                                        characters, but some unsupported/unsafe characters will be stripped.  If you need login control for your reports, use
                                        account contacts instead.</p>
                                </v-row>
                                <v-container>
                                    <v-row  justify="space-between" style="width:100%">
                                        <v-checkbox :input-value="reports_checkstatus.reportCheck.public" :label="getLabel('public')"  @click.stop="saveToCheck(!reports_checkstatus.reportCheck.public, 'public')" ></v-checkbox>
                                    </v-row>
                                    <v-row  justify="space-between" style="width:100%">
                                        <v-textarea name="title" :value="reports_checkstatus.reportConfig.check.title" :label="getLabel('title')" rows="2" auto-grow  @change="saveCheckConfig($event, 'title')">
                                        </v-textarea>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-text-field name="pagetitle" :value="reports_checkstatus.reportConfig.check.pagetitle" :label="getLabel('pagetitle')" @change="saveCheckConfig($event, 'pagetitle')" >
                                        </v-text-field>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-text-field name="accessphrase" :value="reports_checkstatus.reportConfig.check.accessphrase" :label="getLabel('accessphrase')" @change="saveCheckConfig($event, 'accessphrase')" >
                                        </v-text-field>
                                    </v-row>
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header  class='sectiontitle'>Summary Panel</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="helpicon" >
                                    <v-icon light right color="primary" @click="togglehelp('checksummaryhelp')">{{ getIcon('help') }}</v-icon>
                                </div>
                                <v-row  class='helptext' id="checksummaryhelp"  v-if="showhelp === 'checksummaryhelp'">
                                    <p>The <strong>Summary Panel</strong> is used to summarize the overall status for the check.  You can set the text it will show
                                    if the check is up or down.  These text fields support filtered HTML, as well as variables for {label},
                                    {target} and {type}.</p>
                                    <p>The block can be styled using the CSS settings under "Custom Content" below.  The summary panel has an ID
                                        of "statusoverview", with classes available to style both up and down states ("summarytitleup" and "summarytitledown").<br />
                                        Note that in order to override the styles already set in the page, you'll need to be fairly specific or use !important. For example:
                                        setting the background color for .summaryblockdown won't work, but it does if you set it on div.dashboard.summaryblockdown.</p>
                                </v-row>
                                <v-container>
                                    <v-row style="width:100%">
                                        <v-checkbox :input-value="reports_checkstatus.reportConfig.check.showsummary" :label="getLabel('showsummary')" @click.stop="saveCheckConfig(!reports_checkstatus.reportConfig.check.showsummary, 'showsummary')" ></v-checkbox>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-text-field name="summarytitleup" :value="reports_checkstatus.reportConfig.check.summarytitleup" :label="getLabel('summarytitleup')" @change="saveCheckConfig($event, 'summarytitleup')" >
                                        </v-text-field>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-text-field name="summarytitledown" :value="reports_checkstatus.reportConfig.check.summarytitledown" :label="getLabel('summarytitledown')" @change="saveCheckConfig($event, 'summarytitledown')" >
                                        </v-text-field>
                                    </v-row>
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header class='sectiontitle'>
                                Check Properties
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="helpicon" >
                                    <v-icon light right color="primary" @click="togglehelp('checkhelp')">{{ getIcon('help') }}</v-icon>
                                </div>
                                <v-row class="helptext" id="checkhelp" v-if="showhelp === 'checkhelp'"  >
                                    <p>The <strong>Check Properties</strong> block can display the key fields from the check's setup, as
                                        well as a link to the URL being monitored (for HTTP type checks).  You can set which check property
                                        fields (if any) are displayed on the report.  Setting any of these makes the settings in this
                                        group of options override the account wide settings completely.</p>
                                    <p><strong>Hide the target URL from the report</strong> causes the check's "target" field to not be sent to the report at all,
                                        which means it isn't available anywhere, including as a field in the banner.  This is intended to prevent
                                        data leakage, since for some checks the URL might be non-public information.</p>
                                    <p><strong>Note that if you turn off "Hide the target URL" it may take a minute or so for the link to display</strong>,
                                        since the prior setting means we won't have cached it for the browser.</p>
                                </v-row>
                                <v-container>
                                    <v-row style="width:100%">
                                        <v-checkbox :input-value="reports_checkstatus.reportConfig.check.showcheckproperties" :label="getLabel('hidecheckproperties')"  @click.stop="saveCheckConfig(!reports_checkstatus.reportConfig.check.hidecheckproperties, 'hidecheckproperties')" ></v-checkbox>
                                    </v-row>
                                    <v-row>
                                        <v-checkbox :input-value="reports_checkstatus.reportConfig.check.hidetarget" :label="getLabel('hidetarget')"  @click.stop="saveCheckConfig(!reports_checkstatus.reportConfig.check.hidetarget, 'hidetarget')" ></v-checkbox>
                                    </v-row>
                                    <v-row><h3>Individual Properties</h3></v-row>
                                    <v-row >
                                        <div class="col-md-6 col-sm-12" v-for="(item, idx) in showCheckProps" v-bind:key="'configaccountcheckprops-' + idx">
                                            <v-checkbox :input-value="item.show" :label="item.title" @click.stop="saveCheckConfig(!item.show, 'showprops', item.field)" ></v-checkbox>
                                        </div>
                                    </v-row>
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header class='sectiontitle'>
                                Uptime
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="helpicon" >
                                    <v-icon light right color="primary" @click="togglehelp('uptimehelp')">{{ getIcon('help') }}</v-icon>
                                </div>
                                <v-row class="helptext" id="uptimehelp" v-if="showhelp === 'uptimehelp'"  >
                                    <p>You can toggle whether or not to show uptime on the status page.</p>
                                    <p>The <strong>Uptime Timeframe</strong> setting allows you to choose how uptime information will be displayed on the page.  Since what
                                    uptime data we fetch from the database is dependent on this setting, when you change this the data may not be immediately available, but
                                    it will refresh within a few seconds of closing the configuration panel. </p>
                                </v-row>
                                <v-container>
                                    <v-row  style="width:100%">
                                        <v-checkbox :input-value="reports_checkstatus.reportConfig.check.showuptime" :label="getLabel('hideuptime')"  @click.stop="saveCheckConfig(!reports_checkstatus.reportConfig.check.hideuptime, 'hideuptime')" ></v-checkbox>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-select :items="uptimespanoptions" :label="getLabel('uptimespan')" :value="reports_checkstatus.reportConfig.check.uptimespan" @input="saveCheckConfig($event, 'uptimespan')" />
                                    </v-row>
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header class='sectiontitle'>
                                Check Results
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="helpicon" >
                                    <v-icon light right color="primary" @click="togglehelp('resultshelp')">{{ getIcon('help') }}</v-icon>
                                </div>
                                <v-row class="helptext" id="resultshelp" v-if="showhelp === 'resultshelp'"  >
                                    <p>These settings manage how (or even if) results from the check will be displayed on the page.  You can show
                                        results in a graph as well as in a table view.  There is one table listing per check, but you
                                        can add additional graphs to the page.
                                    </p>
                                    <p><strong>The Results Title</strong> will appear above the two results displays, if they are turned on.</p>
                                    <p>If <strong>Show Field to Set Results Count</strong> is on, users will be able to enter set how many results to
                                        show in the chart and table.  Since we get the results for the chart and table at the same time, the setting
                                        applies to both.  By default, the report will display 300 results (5 hours on a 1 minute interval check).
                                        The report also supports putting a number in the URL path of the report, which will be used even if this
                                        field to set it within the page isn't showing.</p>
                                    <p><strong>Results Charts</strong> show a graph of results data. You can toggle them on or off here.
                                        Individual charts are managed below, at the point they appear in the page.  If this configuration
                                        panel is open, each chart will have an "Edit" button. </p>
                                    <p>The charts support line graphs, area graphs, stacked area graphs, and gauges.  Stacked area graphs
                                        are mostly applicable for custom fields on Parse or PUSH checks where you have configured the check to
                                        monitor multiple fields of closely related data.</p>
                                    <p>The <strong>Results Table</strong> displays invididual results in a table view.  You can set whether
                                        results fields will appear on the table, and label the columns.
                                        If a check has additional custom fields (<a href='/http_parse_check.html' target='_blank'>HTTP Parse</a>
                                        and <a href='/push_check.html' target='_blank'>PUSH</a> checks, for example), they can added to the table
                                        here as well.</p>
                                    <p>The <strong>Hide/Show Button</strong> will cause the table to not be shown when the page initially loads.
                                        Instead, there will be a button labeled "Show Results" that will display the table.  This toggle only works
                                        if the Results Table is enabled.</p>
                                </v-row>
                                <v-container>
                                    <v-row  justify="space-between" style="width:100%">
                                        <v-text-field name="resultstitle" :value="reports_checkstatus.reportConfig.check.resultstitle" :label="getLabel('resultstitle')" @change="saveCheckConfig($event, 'resultstitle')" >
                                        </v-text-field>
                                    </v-row>
                                    <div class="showcheckfieldrow d-flex flex-wrap" >
                                        <v-checkbox :input-value="reports_checkstatus.reportConfig.check.showresultslimit" :label="getLabel('showresultslimit')"  @click.stop="saveCheckConfig(!reports_checkstatus.reportConfig.check.showresultslimit, 'showresultslimit')" ></v-checkbox>
                                    </div>
                                    <div class="sectionhead"><h3>Result Chart Settings</h3></div>
                                    <div class="showcheckfieldrow d-flex flex-wrap" >
                                        <v-checkbox :input-value="reports_checkstatus.reportConfig.check.showchart" :label="getLabel('hidechart')"  @click.stop="saveCheckConfig(!reports_checkstatus.reportConfig.check.hidechart, 'hidechart')" ></v-checkbox>
                                    </div>
                                    <!-- Results Table -->
                                    <div class="sectionhead"><h3>Result Table Settings</h3></div>
                                    <div class="showcheckfieldrow d-flex flex-wrap" >
                                        <v-checkbox :input-value="reports_checkstatus.reportConfig.check.showresultslist" :label="getLabel('hideresultslist')"  @click.stop="saveCheckConfig(!reports_checkstatus.reportConfig.check.hideresultslist, 'hideresultslist')" ></v-checkbox>
                                    </div>
                                    <div class="showcheckfieldrow d-flex flex-wrap" >
                                        <v-checkbox :input-value="reports_checkstatus.reportConfig.check.showresultstoggle" :label="getLabel('showresultstoggle')"  @click.stop="saveCheckConfig(!reports_checkstatus.reportConfig.check.showresultstoggle, 'showresultstoggle')" ></v-checkbox>
                                    </div>
                                    <v-row  justify="space-between">
                                        <v-text-field name="resultstabletitle" :value="reports_checkstatus.reportConfig.check.resultstabletitle" :label="getLabel('resultstabletitle')" @change="saveCheckConfig($event, 'resultstabletitle')" >
                                        </v-text-field>
                                    </v-row>
                                    <v-row  class="sectionhead">
                                        <h3>Fields to Display in Table</h3>
                                    </v-row>
                                    <v-row justify="space-between" v-for="(item, idx) in checkResultsTableFields" v-bind:key="'resultstable-' + idx">
                                        <div class="col-md-6 col-sm-12">
                                            <v-checkbox :input-value="item.show" :label="item.text || item.label" @click.stop="saveCheckConfig(!item.show, 'resultstable', 'show', item.field)" ></v-checkbox>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                            <v-text-field :value="item.label" label="Label" @change="saveCheckConfig($event, 'resultstable', 'label', item.field)" />
                                        </div>
                                    </v-row>
                                    <div class="tableextfieldsgroup" v-if="checkResultsTableParseFields">
                                        <v-row justify="space-between" v-for="(item, idx) in checkResultsTableParseFields" v-bind:key="'configchartextfields-' + idx">
                                            <div class="col-md-6 col-sm-12">
                                                <v-checkbox :input-value="item.show" :label="item.field" @click.stop="saveCheckConfig(!item.show, 'resultstable', 'show', item.key)"></v-checkbox>
                                            </div>
                                            <div class="col-md-6 col-sm-12">
                                                <v-text-field :value="item.label || item.field" label="Label" @change="saveCheckConfig($event, 'resultstable', 'label', item.key)" />
                                            </div>
                                        </v-row>
                                    </div>
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header class='sectiontitle'>
                                Events
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="helpicon" >
                                    <v-icon light right color="primary" @click="togglehelp('eventhelp')">{{ getIcon('help') }}</v-icon>
                                </div>
                                <v-row class="helptext" id="eventhelp" v-if="showhelp === 'eventhelp'"  >
                                    <p>This section allows you to manage how Events History is displayed.</p>
                                    <p><strong>Show Events Block</strong> toggles whether the page will include an events history block.</p>
                                    <p><strong>Events Block Title</strong> allows you to optionally set a title for this part of the page.  The default is "Event History"</p>
                                    <p><strong>Pagination Interval</strong> sets how much event history we get at a time.  The reasonable setting here depends on how many events
                                        there will be for this check.  "All" makes the page display all events from the time the check was created.
                                        Combining this with "Show Days with No Events" is not recommended, because you might end up with a lot of days listed.</p>
                                    <p><strong>Do Not Show Events Older Than</strong> prevents querying for events older than the span of time indicated.</p>
                                    <p><strong>Show Days with No Events</strong> makes the page list each page in the timespan with a "No Events Reported" message (which you can set in the next field)</p>
                                    <p><strong>Text displayed when there are no events</strong> sets what to display if there are no events in the displayed interval (or on that day
                                    if you are displaying empty days).  Defaults to "No events reported".</p>
                                </v-row>
                                <v-container>
                                    <v-row style="width:100%" >
                                        <v-checkbox :input-value="reports_checkstatus.reportConfig.check.showevents" :label="getLabel('hideevents')"  @click.stop="saveCheckConfig(!reports_checkstatus.reportConfig.check.hideevents, 'hideevents')" ></v-checkbox>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-text-field name="eventtitle" :value="reports_checkstatus.reportConfig.check.eventtitle" :label="getLabel('eventtitle')" @change="saveCheckConfig($event, 'eventtitle')" >
                                        </v-text-field>
                                    </v-row>
                                    <v-row> <!-- eventsinterval effectively supports any value accepted as a "key" by moment().subtract().  Others will be invalid dates. -->
                                        <v-select :items="[{value:'all', text:'Get All Events'}, {value:'months', text:'One Month'}, {value:'weeks', text:'One Week'}, {value:'days', text:'One Day'}]" :label="getLabel('eventsinterval')" :value="reports_checkstatus.reportConfig.check.eventsinterval" @input="saveCheckConfig($event, 'eventsinterval')" />
                                    </v-row>
                                    <v-row> <!-- // This must match the allowed values in the server side setup (eventslimitspans).  Other values will be ignored. -->
                                        <v-select :items="[{value:'all', text:'No limit'}, {value:'One week', text:'One Week'}, {value:'Two weeks', text:'Two Weeks'}, {value:'One month', text:'One Month'}, {value:'Three months', text:'Three Months'}]" :label="getLabel('eventsnotbefore')" :value="reports_checkstatus.reportConfig.check.eventsnotbefore" @input="saveCheckConfig($event, 'eventsnotbefore')" />
                                    </v-row>
                                    <v-row>
                                        <v-checkbox :input-value="reports_checkstatus.reportConfig.check.showemptyeventdays" :label="getLabel('showemptyeventdays')" @click.stop="saveCheckConfig(!reports_checkstatus.reportConfig.check.showemptyeventdays, 'showemptyeventdays')" ></v-checkbox>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-text-field name="noeventstext" :value="reports_checkstatus.reportConfig.check.noeventstext" :label="getLabel('noeventstext')" @change="saveCheckConfig($event, 'noeventstext')" >
                                        </v-text-field>
                                    </v-row>
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header class='sectiontitle'>Custom Content - Banner, Footer, Support Content</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="helpicon" >
                                    <v-icon light right color="primary" @click="togglehelp('supportcontenthelp')">{{ getIcon('help') }}</v-icon>
                                </div>
                                <v-row class="helptext" id="supportcontenthelp" v-if="showhelp === 'supportcontenthelp'"  >
                                    <p>The Customizable Content blocks support either plain text or HTML.  A wide range of tags and attributes are supported, but there is some
                                        filtering to prevent misuse.  For example, script tags and event attributes will be removed.  Style attributes are supported, but we
                                        encourage you to use the CSS block instead of adding style attributes.</p>
                                    <p><strong>The Support Content</strong> blocks are intended to show information that is useful to all visitors to the status page.
                                        For example, you may want to display a link to contact support.  Note 1 will appear in between Uptime and Results.  Note 2 will appear
                                        between Results and Events.  Both of those blocks can be toggle on and off without removing the text you have set, which makes them
                                        easy for situational use.  To style this content, use the CSS block.  Both note blocks have a class of "supportnote," and the
                                        IDs are "checknote1" and "checknote2".</p>
                                    <p><strong>The Footer</strong> is at the bottom of the page, and can safely be left blank if you don't need it.  To style the Footer content, use the CSS
                                        block below with the #customfooter id.</p>
                                    <p><strong>The CSS</strong> block will be inserted into the page as the last style block in the page HEAD.  It accepts most standard
                                        <a hre="https://developer.mozilla.org/en-US/docs/Web/CSS/Reference" target="_blank">CSS syntax</a>, although there is some filtering applied.</p>
                                </v-row>
                                <v-container>
                                    <v-row>
                                        <v-checkbox :input-value="reports_checkstatus.reportConfig.check.shownote1" :label="getLabel('hidenote1')" @click.stop="saveCheckConfig(!reports_checkstatus.reportConfig.check.hidenote1, 'hidenote1')" ></v-checkbox>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-textarea name="note1" :value="reports_checkstatus.reportConfig.check.note1" :label="getLabel('note1')" rows="2" auto-grow  @change="saveCheckConfig($event, 'note1')">
                                        </v-textarea>
                                    </v-row>
                                    <v-row>
                                        <v-checkbox :input-value="reports_checkstatus.reportConfig.check.shownote2" :label="getLabel('hidenote2')" @click.stop="saveCheckConfig(!reports_checkstatus.reportConfig.check.hidenote2, 'hidenote2')" ></v-checkbox>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-textarea name="note2" :value="reports_checkstatus.reportConfig.check.note2" :label="getLabel('note2')" rows="2" auto-grow  @change="saveCheckConfig($event, 'note2')">
                                        </v-textarea>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-textarea name="footer" :value="reports_checkstatus.reportConfig.check.footer" :label="getLabel('footer')" rows="2" auto-grow  @change="saveCheckConfig($event, 'footer')">
                                        </v-textarea>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-textarea name="stylecss" :value="reports_checkstatus.reportConfig.check.stylecss" :label="getLabel('stylecss')" rows="2" auto-grow  @change="saveCheckConfig($event, 'stylecss')">
                                        </v-textarea>
                                    </v-row>
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header class='sectiontitle'>
                                Config
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-container>
                                    <v-row>
                                        Check: <br />
                                        <pre>{{reports_checkstatus.reportCheck}}</pre>
                                    </v-row>
                                    <v-row>
                                        Report Config: <br />
                                        <pre>{{reports_checkstatus.reportConfig}}</pre>
                                    </v-row>
                                    <v-row>
                                        showCheckProps: <br />
                                        <pre>{{showCheckProps}}</pre>
                                    </v-row>
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-container>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import appconfig from "../config/shared";
import { mapState } from "vuex";
import { filterHTML, formatCapitalizeFirst } from '../lib/filter';

const fieldSchema = {
    enable: {label: "Check Status Pages Are Public if the Check is Marked Public", shortlabel: "Public" },
    eventsinterval: {label: "Pagination Interval (How much should we fetch at a time?)", shortlabel: "Pagination Interval" },
    eventsnotbefore: {label: "Do Not Show Events Older Than" },
    eventtitle: {label: "Events Block Title (Defaults to \"Event History\")", shortlabel: "Event Blocks Title" },
    footer: {label: "Footer" },
    hidechart: {label: "Show Results Chart" },
    hidecheckproperties: {label: "Show Properties Block" },
    hidecheckuptime: {label: "Show Uptime" },
    hideevents: {label: "Show Events Block" },
    hidenote1: {label: "Show Support Content 1" },
    hidenote2: {label: "Show Support Content 2" },
    hideresultslist: {label: "Show Results List" },
    hidetarget: {label: "Hide Target URL from Report" },
    hideuptime: {label: "Show Uptime" },
    noeventstext: {label: "Text displayed when there are no events (Defaults to \"No events reported\")", shortlabel: "Text displayed when there are no events" },
    note1: {label: "Support Content 1" },
    note2: {label: "Support Content 2" },
    pagetitle: {label: "Page Title (on window or tab)" },
    accessphrase: {label: "Access Phrase" },
    public: {label: "Check Status is Public" },
    resultstable: {label: "Fields in Table" },
    resultstabletitle: {label: "Results Table Title" },
    resultstitle: {label: "Results Block Title" },
    showemptyeventdays: {label: "Show Days with No Events" },
    showprops: {label: "Check Properties" },
    showresultslimit: {label: "Show Field to Set Results Count" },
    showresultstoggle: {label: "Show Results Hide/Show Button" },
    showsummary: {label: "Show Status Summary" },
    stylecss: {label: "CSS" },
    summarytitledown: {label: "Summary when Down (defaults to \"{label} is Down\")", shortlabel: "Summary when down" },
    summarytitleup: {label: "Summary when Up (defaults to \"{label} is Up\")", shortlabel: "Summary when up" },
    title: {label: "Report Banner" },
    uptimespan: {label: "Uptime Timeframe" }    //  pagetitle: {label: "label" },
}

/*
const uptimespans = {
    "Uptime for today": true,
    "Gauge for today": true,
    "Uptime for today and 30 days": true,
    "Uptime for seven days + 30 days": true,
    "Uptime for one, three, seven and 30 days": true,
    "Gauge for today and 30 days": true,
    "Gauge for seven days + 30 days": true,
    "Gauge for one, three, seven and 30 days": true,
    "Monthly Uptime": true,
    "Gauge: seven days": true,
    "Uptime for seven days": true
};
*/
export default {
    name: "ReportSettings",
    props: { reportid: { type: String} },
    components: {},
    data () {
        return {
            manageDefaults: false,
            showtable: false,
            showhelp: false,
            uptimespanoptions: [  // This must match the allowed values in the server side setup.  Other values will be ignored.
                "Uptime for seven days",
                "Gauge for seven days",
                "Uptime for seven days + 30 days",
                "Uptime for today",
                "Gauge for today",
                "Uptime for today and 30 days",
                "Gauge for today and 30 days",
                "Uptime for one, three, seven and 30 days",
                "Gauge for one, three, seven and 30 days",
                "Monthly Uptime"
            ],
            graphtypesavailable: ['Line Graph','Area Graph','Area Graph Stacked', "Stepped Area Chart"]
        }
    },
    computed: {
        ...mapState(["currentUser", "reports_checkstatus", "now"]),
        // checkConfig: function () {
        //     return (
        //         this.reports_checkstatus.reportCheck &&
        //         this.reports_checkstatus.reportConfig &&
        //         this.reports_checkstatus.reportConfig.check ) || {}
        // },
        showCheckProps: function () {
            let display =
                ( this.reports_checkstatus.reportConfig &&
                    ( (this.reports_checkstatus.reportConfig.check && this.reports_checkstatus.reportConfig.check.showprops) ||
                      this.reports_checkstatus.reportConfig.showprops )
                ) || {};
            let props = {};
            for(let k in this.reports_checkstatus.checkPropsSchema){
                if(display[k] === undefined){
                    display[k] = {}
                } else if(display[k] === true || display[k] === false){
                    display[k] = { show: display[k] }
                }
                props[k] = Object.assign({}, this.reports_checkstatus.checkPropsSchema[k], display[k]);
            }
            return props;
        },
        showAccountCheckProps: function () {
            let display = ( this.reports_checkstatus.reportConfig && this.reports_checkstatus.reportConfig.showprops ) || {};
            let props = {};
            for(let k in this.reports_checkstatus.checkPropsSchema){
                if(display[k] === undefined){
                    display[k] = {}
                } else if(display[k] === true || display[k] === false){
                    display[k] = { show: display[k] }
                }
                props[k] = Object.assign({}, this.reports_checkstatus.checkPropsSchema[k], display[k]);
            }
            return props;
        },
        checkResultsTableFields: function () {
            const defaults = { time: true, rt: true, sc: true, l: true, m: true, su: true };
            let conf = this.reports_checkstatus.reportConfig.check.resultstable || this.reports_checkstatus.reportConfig.resultstable || defaults;
            let fields = {};
            for(let k in this.reports_checkstatus.resultsSchema){
                // if(conf[k] && conf[k].show === false) continue;
                fields[k] = {
                    field: k,
                    label: (conf[k] && (conf[k].label || conf[k].text)) || this.reports_checkstatus.resultsSchema[k].text,
                    show: conf[k] && (conf[k] === true || conf[k].show)
                };
                if(!fields[k].label || fields[k].label === "" || fields[k].label === " " ) fields[k].label = this.reports_checkstatus.resultsSchema[k].label || k.toUpperCase();
            }
            return fields;
            // return this.reports_checkstatus.resultsSchema;
        },
        checkResultsTableParseFields: function () {
            let fields = (this.reports_checkstatus.reportCheck && this.reports_checkstatus.reportCheck.fields);
            if(!fields) return false;
            let conf = (this.reports_checkstatus.reportConfig && this.reports_checkstatus.reportConfig.check && this.reports_checkstatus.reportConfig.check.resultstable ) || {};
            let out = {};
            for(let k in fields){
                let label;
                if(conf[k] && typeof conf[k] === "object"){
                    label = conf[k].label || conf[k].text;
                }
                if(!label || !label.length){
                    label = fields[k].name && typeof fields[k].name === "string" && fields[k].name.split('.').pop();
                    if(label && label.length) label = formatCapitalizeFirst(label);
                }
                if(!label) continue;
                out[k] = {
                    label: label,
                    field: fields[k].name,
                    show: (conf[k] === true || (conf[k] && conf[k].show)),
                    key: k
                }
            }
            // console.log('checkResultsTableParseFields. config/out', conf, out);
            return out;
        },
        accountResultsTableFields: function () {
            const defaults = { time: true, rt: true, sc: true, l: true, m: true, su: true };
            let conf = this.reports_checkstatus.reportConfig.resultstable || defaults;
            let fields = {};
            for(let k in this.reports_checkstatus.resultsSchema){
                // let entry = (typeof fields[k] === "object") ? {...this.reports_checkstatus.resultsSchema[k], ...fields[k]} : this.reports_checkstatus.resultsSchema[k];
                // if(this.reports_checkstatus.resultsSchema[k] && !entry.hide) headers.push(this.reports_checkstatus.resultsSchema[k])
                fields[k] = {
                    field: k,
                    label: (conf[k] && conf[k].text) || this.reports_checkstatus.resultsSchema[k].text,
                    value: conf[k] && (conf[k] === true || conf[k].show),
                    show: conf[k] && (conf[k] === true || conf[k].show)
                };
                if(!fields[k].label || fields[k].label === "" || fields[k].label === " " ) fields[k].label = this.reports_checkstatus.resultsSchema[k].label || k.toUpperCase();
            }
            return fields;
            // return this.reports_checkstatus.resultsSchema;
        }
    },
    methods: {
        getLabel: function(key) {
            return (fieldSchema[key] && fieldSchema[key].label) || key;
        },
        getShortLabel: function(key, subfield) {
            let label = (fieldSchema[key] && (fieldSchema[key].shortlabel || fieldSchema[key].label)) || key;
            if(subfield) label += ": " + subfield;
            return label;
        },
        /**
         * save update to the report config defaults for check status reports for the account.
         */
        saveConfig: function (val, field, subfield, key) {
            // console.log('saveConfig', field, subfield, val)
            const timestamp =  Date.now().toString(36);

            let handlePropFields = () => {
                let list = this.showAccountCheckProps;
                let p = {};
                for(let k in list){
                    p[k] = !!(list[k].show);
                }
                p[subfield] = !!(val);
                // console.log("setting sc", subfield, val);
                return p;
            };

            let handleResultsTable = () => {
                // let list = this.accountResultsTableFields;
                // let p = {};
                // for(let k in list){
                //     p[k] = !!(list[k].show);
                // }
                // p[subfield] = !!(val);
                // console.log("setting results table fields for check", subfield, val, p);
                // return p;

                let p = Object.assign({}, this.accountResultsTableFields);
                // p.fields = Object.assign({}, this.checkResultsTableParseFields);
                // console.log(p);
                if(typeof p[key] !== "object") p[key] = { show: p[key] } ;
                p[key][subfield] = val;
                // console.log("setting results table fields for account", field, subfield, key, val, p);
                return p;
            };

            let out = {};
            switch(field){
                case "title":
                case "note":
                case "note1":
                case "note2":
                    out[field] = filterHTML(val);
                    break;
                case "resultstable":
                    out[field] = handleResultsTable();
                    break;
                case "showprops":
                    out[field] = handlePropFields();
                    break;
                default:
                    out[field] = val;
            }
            this.$store.dispatch('setAlert', {message: "Saving field: "+this.getShortLabel(field, subfield), key: timestamp, type: "info"})

            this.$store.dispatch('reports_checkstatus/setReportConfig', out)
                .then(() => {
                    this.$store.dispatch('setAlert', {message: "Saved field: "+this.getShortLabel(field, subfield), key: timestamp, type: "success"})
                })
                .catch( (e) => {
                    this.$store.dispatch('setAlert', {message: "Error Saving Field: "+this.getShortLabel(field, subfield), key: timestamp, type: "error"})
                    console.log("error saving config update", e);
                });
        },

        /**
         * save update to report config specific to this check.
         */
        saveCheckConfig: function (val, field, subfield, key) {
            // console.log('saveCheckConfig', field, subfield, key, val);
            const timestamp =  Date.now().toString(36);
            let out = {};

            let handlePropFields = () => {
                let list = this.showCheckProps;
                let p = {};
                for(let k in list){
                    p[k] = !!(list[k].show);
                }
                p[subfield] = !!(val);
                // console.log("setting show props for check", subfield, val, p);
                return p;
            };

            /*
            Results table

                params        resultstable      extresultstable
                --------      ------------      ---------------
                val           true, false       true, false, etc
                field         resultstable      resultstableext
                subfield      'show' 'label'    'show' 'label'
                key           rt, l, su         'RHFLSS'

                {
                    su: {field: "su", label: "Status", show: true},
                    fields: {
                        F3A2WP: {label: "# Assigned", field: "result.namespaces.jobs.active.assigned", show: true, key: "F3A2WP"}
                    }
                }
            */

            let handleResultsTable = () => {
                let p = Object.assign({}, this.checkResultsTableParseFields || {}, this.checkResultsTableFields);
                // p.fields = Object.assign({}, this.checkResultsTableParseFields);
                // console.log(p);
                if(typeof p[key] !== "object") p[key] = { show: p[key] } ;
                p[key][subfield] = val;
                // console.log("setting results table fields for check", field, subfield, key, val, p);
                return p;
            };

            // let handleResultsTableExt = () => {
            //     let p = Object.assign({}, this.checkResultsTableParseFields, this.checkResultsTableFields);
            //     p.fields = Object.assign({});
            //     p.fields[key] = (typeof p.fields[key] === "object") ? {} : { show: p.fields[key] } ;
            //     p.fields[key][subfield] = val;
            //     console.log("setting results table extended fields for check", subfield, val, p);
            //     return p;
            // };

            switch(field){
                case "title":
                case "note":
                    out[field] = filterHTML(val);
                    break;
                case "resultstable":
                    out[field] = handleResultsTable();
                    break;
                // case "resultstableext":
                //     field = "resultstable";
                //     out[field] = handleResultsTableExt();
                //     break;
                case "showprops":
                    out[field] = handlePropFields();
                    break;
                default:
                    out[field] = val;
            }

            // console.log('keys', Object.keys(this.showCheckProps));
            // console.log(this.showCheckProps.description.show)
            // console.log('saveCheckConfig ready to send', field, subfield, val, out);
            this.$store.dispatch('setAlert', {message: "Saving field: "+this.getShortLabel(field, subfield), key: timestamp, type: "info"})

            return this.$store.dispatch('reports_checkstatus/setReportCheckConfig', out)
                .then( (result) => {
                    // console.log('saveCheckConfig returned from setReportCheckConfig', field, result)
                    this.$store.dispatch('setAlert', {message: "Saved field: "+this.getShortLabel(field, subfield), key: timestamp, type: "success"})
                    if(field === "uptimespan"){
                        this.$store.dispatch('reports_checkstatus/getUptime', { reportid: this.reportid });
                    }
                })
                .catch( (e) => {
                    this.$store.dispatch('setAlert', {message: "Error Saving Field: "+this.getShortLabel(field, subfield), key: timestamp, type: "error"})
                    console.log('saveCheckConfig ERROR', e);
                });

        },

        /**
         * Save to the check itself, not just in the report configuration.
         * This is primarily used here for the private toggle on the check.
         * Calls methods in the checks store module.
         */
        saveToCheck: function (val, field) {
            // console.log('saveToCheck', field, val)
            const timestamp =  Date.now().toString(36);
            this.$store.dispatch('setAlert', {message: "Saving field: "+this.getShortLabel(field), key: timestamp, type: "info"})
            let record = {
                _id: this.reports_checkstatus.reportCheck._id
            };
            record[field] = val;
            this.$store.dispatch('checks/setCheck', record)
                .then( (result) => {
                    // console.log('saveToCheck returned from setCheck', result);
                    this.$store.dispatch('setAlert', {message: "Saved field: "+this.getShortLabel(field), key: timestamp, type: "success"})
                    this.$store.dispatch('reports_checkstatus/setReportCheck', {field: field, value: val})
                        .then( (r2) => {
                            // console.log('returned from setReportCheck', r2);
                        });
                    // console.log("setCheck", result);
                })
                .catch( (e) => {
                    this.$store.dispatch('setAlert', {message: "Error Saving Field: "+this.getShortLabel(field), key: timestamp, type: "error"})
                    console.log("saveToCheck ERROR", e);
                });
        },
        togglehelp: function (topic) {
            this.showhelp = (this.showhelp === topic) ? null : topic;
        },
        getIcon: function ( val ) {
            return appconfig.icons[val] || val;
        }
    },
    filters: {

    }
}
</script>

<style scoped>
    .helptext p {
        width: 96%;
    }
    .sectiontitle {
        font-weight: bold;
        font-size: 1.1em;
    }
    .showcheckfieldrow .v-input--selection-controls{
        margin-top: 2px;
        padding-top: 2px;
    }
    .importantnote {
        font-size: 1.2em;
        font-weight: bold;
    }
    .helpicon {
        float: right;
    }
    .helptext {
        background-color: #EEE;
        padding: .8rem;
    }
    .tableextfieldsgroup {
        border-top: 1px solid #EEE;
    }
    .configlead {
        padding: 0 12px;
    }
</style>